import { memo, useEffect } from 'react';

import WebApp from '@twa-dev/sdk';
import clsx from 'clsx';
import { createPortal } from 'react-dom';

import { getIsSlowDevice } from '@/shared/helpers/get-is-slow-device';
import { Lottie } from '@/shared/hocs/lottieWrapper';

import screenConfetti from '@/assets/lotties/confetti.lottie?url';
import bottomConfetti from '@/assets/lotties/playcoin-confetti.lottie?url';

import { useConfettiActions, useConfettiState } from '../model';
import { ConfettiVariant } from '../model/types';

import s from './index.module.scss';

const CONFETTI_URL_BY_VARIANT: Record<ConfettiVariant, string> = {
  [ConfettiVariant.bottom]: bottomConfetti,
  [ConfettiVariant.screen]: screenConfetti,
  [ConfettiVariant.paid]: bottomConfetti,
};

export const Confetti = memo(() => {
  const confetties = useConfettiState();
  const { remove } = useConfettiActions();

  const isSlowDevice = getIsSlowDevice();

  useEffect(() => {
    if (isSlowDevice) {
      confetties.forEach(() => {
        remove();
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confetties.length, isSlowDevice]);

  if (isSlowDevice) return null;

  return (
    <>
      {confetties.map(({ key, variant }) =>
        createPortal(
          <Lottie
            key={key}
            src={CONFETTI_URL_BY_VARIANT[variant]}
            workerId={'confetti-lottie-' + key}
            className={clsx(s.confetti, s[variant])}
            onComplete={() => remove()}
            loop={false}
            resetOnResume
            onPlay={() => WebApp.HapticFeedback.notificationOccurred('success')}
          />,
          document.body
        )
      )}
    </>
  );
});
